(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["concierge-modal-maleia"] && !Shopify.designMode) return;
  try {
    
  class ConciergeModal {
    constructor(overlay) {
      this.overlay = overlay;
      this.lastFocus = null;
      overlay.removeAttribute('hidden');
      overlay.addEventListener('click', (e) => { if (e.target === overlay) this.close(); });
      overlay.querySelectorAll('[data-cmx-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && overlay.classList.contains('is-open')) this.close(); });
      // auto-open right after a submit, but NOT on a manual page refresh
      var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
      if (overlay.querySelector('[data-cmx-posted]') && nav.type !== 'reload') this.open();
    }
    open() {
      this.lastFocus = document.activeElement;
      this.overlay.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      const f = this.overlay.querySelector('input, textarea, button');
      if (f) setTimeout(() => f.focus(), 120);
    }
    close() {
      this.overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (this.lastFocus) this.lastFocus.focus();
    }
  }

  (function () {
    const overlay = document.querySelector('[data-cmx-overlay]');
    if (!overlay) return;
    const modal = new ConciergeModal(overlay);
    // hook any "Speak with concierge" trigger
    function isTrigger(el) {
      const a = el.closest('a, button'); if (!a) return null;
      // Only the "Speak with concierge" button opens the modal — NOT the
      // Concierge nav link (which must navigate to /pages/concierge).
      const txt = (a.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (txt.includes('speak with concierge')) return a;
      return null;
    }
    document.addEventListener('click', (e) => {
      const t = isTrigger(e.target);
      if (t) { e.preventDefault(); modal.open(); }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecomuz-blog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('[data-ejr]').forEach(function (root) {
      root.classList.add('is-anim');
      root.querySelectorAll('.ejr-r').forEach(function (el) { io.observe(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-maleia"] && !Shopify.designMode) return;
  try {
    
  class FeaturedProductsMaleia {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-fpm-track]');
      this.fill = root.querySelector('[data-fpm-fill]');
      this.prev = root.querySelector('.fpm__arrow--prev');
      this.next = root.querySelector('.fpm__arrow--next');
      if (!this.track) return;
      this.next && this.next.addEventListener('click', () => this.scroll(1));
      this.prev && this.prev.addEventListener('click', () => this.scroll(-1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      window.addEventListener('resize', () => this.update());
      // Shared mobile bar (image swipes; add-to-cart + title stay/animate)
      this.mbar = root.querySelector('[data-fpm-mbar]');
      this.mbarName = root.querySelector('[data-fpm-mbar-name]');
      this.mbarPrice = root.querySelector('[data-fpm-mbar-price]');
      this.mbarAtc = root.querySelector('[data-fpm-mbar-atc]');
      this._mcard = this.track.querySelector('.fpm__card');
      if (this.mbarAtc) {
        this.mbarAtc.addEventListener('click', () => {
          const card = this._mcard || this.track.querySelector('.fpm__card');
          const form = card && card.querySelector('.fpm__atc');
          if (form) { form.requestSubmit ? form.requestSubmit() : form.submit(); }
        });
      }
      this.update();
    }
    updateMbar() {
      if (!this.mbar || window.innerWidth > 749) return;
      const cards = this.track.querySelectorAll('.fpm__card');
      if (!cards.length) return;
      const idx = Math.max(0, Math.min(cards.length - 1, Math.round(this.track.scrollLeft / this.step())));
      const card = cards[idx];
      if (!card || card === this._mcard) { if (card) this._mcard = card; return; }
      this._mcard = card;
      const nameEl = card.querySelector('.fpm__name');
      const priceEl = card.querySelector('.fpm__price');
      const name = nameEl ? nameEl.textContent.trim() : '';
      const href = nameEl ? nameEl.getAttribute('href') : '';
      const priceHtml = priceEl ? priceEl.innerHTML : '';
      this.mbar.classList.add('is-changing');
      clearTimeout(this._mt);
      this._mt = setTimeout(() => {
        if (this.mbarName) { this.mbarName.textContent = name; if (href) this.mbarName.setAttribute('href', href); }
        if (this.mbarPrice) this.mbarPrice.innerHTML = priceHtml;
        this.mbar.classList.remove('is-changing');
      }, 170);
    }
    step() {
      const card = this.track.querySelector('.fpm__card');
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 24;
      return card ? card.getBoundingClientRect().width + gap : 300;
    }
    scroll(dir) { this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' }); }
    update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      const visible = t.scrollWidth > 0 ? t.clientWidth / t.scrollWidth : 1;
      const pos = max > 0 ? t.scrollLeft / max : 0;
      if (this.fill) {
        const w = Math.min(100, visible * 100);
        this.fill.style.width = w + '%';
        this.fill.style.left = pos * (100 - w) + '%';
      }
      if (this.prev) this.prev.disabled = t.scrollLeft <= 1;
      if (this.next) this.next.disabled = t.scrollLeft >= max - 1;
      this.updateMbar();
    }
  }
  document.querySelectorAll('[data-fpm]').forEach((el) => new FeaturedProductsMaleia(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-collection-maleia"] && !Shopify.designMode) return;
  try {
    
  class ImageCollectionMaleia {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-icm-track]');
      this.fill = root.querySelector('[data-icm-fill]');
      this.prev = root.querySelector('.icm__arrow--prev');
      this.next = root.querySelector('.icm__arrow--next');
      if (!this.track) return;
      this.next && this.next.addEventListener('click', () => this.scroll(1));
      this.prev && this.prev.addEventListener('click', () => this.scroll(-1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      window.addEventListener('resize', () => this.update());
      this.update();
    }
    step() {
      const card = this.track.querySelector('.icm__card');
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 24;
      return card ? card.getBoundingClientRect().width + gap : 300;
    }
    scroll(dir) { this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' }); }
    update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      const visible = t.scrollWidth > 0 ? t.clientWidth / t.scrollWidth : 1;
      const pos = max > 0 ? t.scrollLeft / max : 0;
      if (this.fill) {
        const w = Math.min(100, visible * 100);
        this.fill.style.width = w + '%';
        this.fill.style.left = pos * (100 - w) + '%';
      }
      if (this.prev) this.prev.disabled = t.scrollLeft <= 1;
      if (this.next) this.next.disabled = t.scrollLeft >= max - 1;
    }
  }
  document.querySelectorAll('[data-icm]').forEach((el) => new ImageCollectionMaleia(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-maleia"] && !Shopify.designMode) return;
  try {
    
  class ReviewsMaleia {
    constructor(root) {
      this.track = root.querySelector('[data-rv-track]');
      this.prev = root.querySelector('.rv__arrow--prev');
      this.next = root.querySelector('.rv__arrow--next');
      if (!this.track) return;
      this.next && this.next.addEventListener('click', () => this.scroll(1));
      this.prev && this.prev.addEventListener('click', () => this.scroll(-1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      window.addEventListener('resize', () => this.update());
      this.update();
    }
    step() {
      const card = this.track.querySelector('.rv__card');
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 28;
      return card ? card.getBoundingClientRect().width + gap : 320;
    }
    scroll(dir) { this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' }); }
    update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      if (this.prev) this.prev.disabled = t.scrollLeft <= 1;
      if (this.next) this.next.disabled = t.scrollLeft >= max - 1;
    }
  }
  document.querySelectorAll('[data-rv]').forEach((el) => new ReviewsMaleia(el));

  } catch(e) { console.error(e); }
})();
})();
